import { render, staticRenderFns } from "./ClubOrPrivatePost.vue?vue&type=template&id=167d234f&"
import script from "./ClubOrPrivatePost.vue?vue&type=script&lang=ts&"
export * from "./ClubOrPrivatePost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports